import ManagementPage from "./ManagementPage";

export default ManagementPage;
